export const PRIMARY = '#CB6BE6';
export const HOVER = '#DEC9EA';
// export const PRIMARY = '#38B6FF';
// export const HOVER = '#769ECB';
export const BLACK = '#333';
export const GRAY = '#7E7E7E';
export const BACKGROUND = '#FBFCFC';
export const SECONDARY_BACKGROUND = '#F0F2F9';



// WEBPACK FOOTER //
// ./src/style/constants.js